
import io from 'socket.io-client';


// Namespace maintenance
// forceNew: true it's create instances connections
const maintenance = io(`${process.env.RAZZLE_REACT_APP_API_DOMAIN}/maintenance`, { forceNew: true, transports: ['websocket', 'polling'] });

export default maintenance;
